import React from "react";
import TextFloralBg from "../SVG/TextFloralBg";
import * as styles from "../../styles/menu/productList.module.css";
import TextDivider1 from "../SVG/TextDivider1";

function ProductList({
  filteredData,
  Card,
  cardProps,
  className,
  menuProducts,
  disabled=false
}) {
  return (
    <div className={`${styles.productContainer} ${disabled&&styles.disabled} ${className}`}>
      {filteredData.map((courseInfo, index) => {
        //Check if menuProducts has this courseName
        const hasCourseName = menuProducts
          ? courseInfo.courseName in menuProducts
          : false;
        return (
          <React.Fragment key={index}>
            <TextFloralBg
              id={`${courseInfo.courseName.replace(/\s/g, "")}`}
              className={styles.floralContainer}
              textClassName={styles.courseText}
            >
              {courseInfo.courseName}
            </TextFloralBg>
            {courseInfo.menuInfo.map((menuInfo, index) => {
              return (
                <React.Fragment key={index}>
                  <TextDivider1
                    id={`${menuInfo.menuCategory.replace(/\s/g, "")}`}
                    className={styles.menuCategory}
                  >
                    {menuInfo.menuCategory}
                  </TextDivider1>
                  <div className={styles.cardCollection} key={index}>
                    {menuInfo.products.map((product, index) => {
                      //Check if card exists in menu already
                      var exists = false; 
                      if (hasCourseName) {
                        for (
                          let i = 0;
                          i < menuProducts[courseInfo.courseName].length;
                          i++
                        ) {
                          //Check if this product is there in the list of products under the courseName
                          if (
                            menuProducts[courseInfo.courseName][i].name ===
                            product.name
                          ) {
                            exists = true;
                            break;
                          }
                        }
                      }
                      return (
                        <Card
                          key={index}
                          product={product}
                          courseInfo={courseInfo}
                          menuInfo={menuInfo}
                          {...cardProps}
                          cardSelected={exists}
                        />
                      );
                    })}
                  </div>
                </React.Fragment>
              );
            })}
          </React.Fragment>
        );
      })}
    </div>
  );
}

export default ProductList;
